/**
 * This is a test placement, which registers all test messages with the placement.
 * You can use this for stories, preview or for development.
 *
 * To use this for in-app development with local consumption you can import the frontend directly like so:
 *
 * import { TestPlacement } from @post-office/placements--cc-ai/test/audio-button-spotlight
 *
 * Although this file has been generated, you are free to edit the file without it being overwritten.
 * If you want to recreate this file run "yarn placement:v2 dev --overwrite"
 */

import { PlacementBackend, PlacementFrontend } from '../index';

import { createPlacementTestComponent } from '@post-office/placement-common-v2/placement-test-util';
import { MessageFrontend as createMessageFrontendYourTestMessage } from '../test-messages';

const messageFrontends = [
	createMessageFrontendYourTestMessage({
		messageTemplateId: 'audio-button-spotlight-test-message',
	}),
];

export const placementBackendFactory = PlacementBackend.createPlacementBackend({
	messageTemplates: [],
});

export const Placement = PlacementFrontend.createPlacementFrontendComponent({
	messageTemplates: messageFrontends,
});

export const TestPlacement = createPlacementTestComponent({ Placement });
